import { render, staticRenderFns } from "./TableRowsPerPage.vue?vue&type=template&id=0e5c6054&"
import script from "./TableRowsPerPage.vue?vue&type=script&lang=ts&"
export * from "./TableRowsPerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports